export enum BottomPadding {
  Small = 'Small',
  Large = 'Large',
  None = 'None',
}

export enum IconPosition {
  Left = 'left',
  Right = 'right',
}
